module.exports = __webpack_public_path__ + "static/media/pawritten.de0c3aec.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten.woff
// module id = ./src/assets/fonts/pawritten.woff
// module chunks = 6